import styled from "styled-components";
import ThemeToggle from "./ThemeToggle";
import Logo from "./Logo";

const StyledHeader = styled.header`
  background-color: var(--color-grey-200);
  height: 5rem;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

function Header() {
  return (
    <StyledHeader>
      <Logo />
      <ThemeToggle />
    </StyledHeader>
  );
}

export default Header;
